import PropTypes from "prop-types";
import React, { Component } from "react";
import { Alert, Button, Card, CardBody, Col, Container, Row, Label } from "reactstrap";

import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";

// Redux
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

//Import Breadcrumb
import Breadcrumb from "../../components/Common/Breadcrumb";

import avatar from "../../assets/images/users/avatar-1.jpg";
// actions
import { editProfile, resetProfileFlag } from "../../store/actions";
import {getLabDetail, getLabDetailSuccess, getLabDetailFail} from "../../store/actions";
import {updateLabRequest, updateLabSuccess, updateLabFail, uploadRequest } from "../../store/actions";
class LabProfile1 extends Component {
  constructor(props) {
    super(props);
    this.state = { 
     email: "Shifa@mail.com",
     name: "", 
    //  address: "",
     contact: "",
    //  landline_number: "",
    //  health_department_id: "",
     lab:"",
     labs:{
      name: "", 
     address: "",
     contact: "",
     landline_number: "",
     health_department_id: "",
     }
     


};
  }

  componentDidMount() {
    if (localStorage.getItem("authUser")) {
      const obj = JSON.parse(localStorage.getItem("authUser"));
      console.log(obj);
      console.log("Lab Email");
      console.log(obj.email);
        this.setState({
          name: obj.name,
          email: obj.email,
          contact: obj.contact_number,
        });
        const { lab, onGetLab } = this.props;
    const emaill = this.state.email;
    console.log("LAB ")
    console.log(this.state.email)
    const email1=obj.email
      onGetLab(email1);
    this.setState({lab});
    console.log("lab objectt " +JSON.stringify(lab));
   

        
    }
    
  }
  

  
  componentDidUpdate(prevProps, prevState, ss) {
     if (this.props !== prevProps) {
       const obj = JSON.parse(localStorage.getItem("authUser"));
         this.setState({
           name: obj.name,
          email: obj.email,
           Contact: obj.contact_number,
         });
         const { lab } = this.props;
         const emaill = this.state.email;
         this.setState({lab});
         console.log("lab number " +this.state.lab.address);
         console.log("lab email " +this.state.email);
         
    
  }}
  
  
  render() {
    const lab= this.props.lab
    
    
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            {/* Render Breadcrumb */}
            <Breadcrumb title="Dashboard" breadcrumbItem="View Profile" />

            <Row>
              <Col lg="12">
                {/* {this.props.error && this.props.error ? (
                  <Alert color="danger">{this.props.error}</Alert>
                ) : null}
                {this.props.success && this.props.success ? (
                  <Alert color="success">{this.props.success}</Alert>
                ) : null} */}

                <Card>
                  <CardBody>
                    <div className="d-flex">
                      <div className="me-3">
                        <img
                          src={avatar}
                          alt=""
                          className="avatar-md rounded-circle img-thumbnail"
                        />
                      </div>
                      <div className="align-self-center flex-1">
                        <div className="text-muted">
                          <h5>{this.state.name}</h5>
                          <p className="mb-1">{this.state.email}</p>
                          <p className="mb-1">Contact no: #{this.state.contact}</p>
                          <p className="mb-0">Health Department ID: #{this.state.lab.health_department_id}</p>
                          
                        </div>
                      </div>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>

            <h4 className="card-title mb-4">Update Profile Details</h4>

            <Card>
              <CardBody>
                <Formik
                  enableReinitialize={true}
                  initialValues={{
                    username: (this.state.labs && this.state.labs.name) || "",
                    address: (this.state.labs && this.state.labs.address) || "",
                    contact: (this.state.labs && this.state.labs.contact) || "",
                    landline_number: (this.state.labs && this.state.labs.landline_number) || "",
                    health_department_id: (this.state.labs && this.state.labs.health_department_id) || "",

                  }}
                  validationSchema={Yup.object().shape({
                    username: Yup.string().required(
                      "Please Enter Your Username"
                    ),
                    address: Yup.string().required(
                      "Please Enter Your Address"
                    ),
                    contact: Yup.string().required(
                      "Please Enter Your Contact"
                    ),
                    landline_number: Yup.string().required(
                      "Please enter your landline number"
                    ),
                  })}
                  onSubmit={values => {
                    const updatedlab = {
                    
                      name:values.username,
                      address:values.address, 
                      contact_number:values.contact,
                      landline_number: values.landline_number,
                      health_department_id:values.health_department_id
                    
                    };
                    const labs=this.state.lab;
                    const Email= this.state.email;
                    console.log("lab email from updated " +labs.email);

                    this.props.onUpdateLab(updatedlab, lab.email);
                    console.log("lab email after updatelab called" +lab.email);
                   
                  }}
                >
                  {({ errors, status, touched }) => (
                    <Form className="form-horizontal">
                      <div className="mb-3">
                        <Label for="username" className="form-label">
                          Username
                        </Label>
                        <Field
                          name="username"
                          placeholder= {this.state.lab.name}
                          type="text"
                          className={
                            "form-control" +
                            (errors.username && touched.username
                              ? " is-invalid"
                              : "")
                          }
                        />
                        <ErrorMessage
                          name="username"
                          component="div"
                          className="invalid-feedback"
                        />
                       
                      </div>
                      <div className="mb-3">
                        <Label for="address" className="form-label">
                          Lab Address
                        </Label>
                        <Field
                          name="address"
                          type="text"
                          placeholder={this.state.lab.address}
                          className={
                            "form-control" +
                            (errors.address && touched.address
                              ? " is-invalid"
                              : "")
                          }
                        />
                        <ErrorMessage
                          name="address"
                          component="div"
                          className="invalid-feedback"
                        />
                       
                      </div>
                      <div className="mb-3">
                        <Label for="landline_number" className="form-label">
                          Lab Landline Number
                        </Label>
                        <Field
                          name="landline_number"
                          type="text"
                          placeholder={this.state.lab.landline_number}
                          className={
                            "form-control" +
                            (errors.landline_number && touched.landline_number
                              ? " is-invalid"
                              : "")
                          }
                        />
                        <ErrorMessage
                          name="landline_number"
                          component="div"
                          className="invalid-feedback"
                        />
                       
                      </div>
                      <div className="mb-3">
                        <Label for="contact" className="form-label">
                          Lab Contact Number
                        </Label>
                        <Field
                          name="contact"
                          type="text"
                          placeholder={this.state.contact}
                          className={
                            "form-control" +
                            (errors.contact && touched.contact
                              ? " is-invalid"
                              : "")
                          }
                        />
                        <ErrorMessage
                          name="contact"
                          component="div"
                          className="invalid-feedback"
                        />
                       
                      </div>
                      <div className="mb-3">
                        <Label for="health_department_id" className="form-label">
                          Health Depratment ID
                        </Label>
                        <Field
                          name="health_department_id"
                          type="text"
                          placeholder={this.state.lab.health_department_id}
                          className={
                            "form-control" +
                            (errors.health_department_id && touched.health_department_id
                              ? " is-invalid"
                              : "")
                          }
                        />
                        <ErrorMessage
                          name="health_department_id"
                          component="div"
                          className="invalid-feedback"
                        />
                       
                      </div>
                      <div className="text-center mt-4">
                        <Button type="submit" color="danger">
                          Update Lab Details
                        </Button>
                      </div>
                    </Form>
                  )}
                </Formik>
              </CardBody>
            </Card>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

LabProfile1.propTypes = {
  editProfile: PropTypes.func,
  error: PropTypes.any,
  lab: PropTypes.object,
  onGetLab: PropTypes.func,
  success: PropTypes.any,
  onUpdateLab: PropTypes.func,
  resetProfileFlag: PropTypes.func,
  loading: PropTypes.bool,
};

const mapStateToProps = state => ({
  lab: state.LabReducer.lab,
  error: state.LabReducer.error,
  loading: state.LabReducer.isLoading,
  // const{ error, success } = state.Profile;
  // return { error, success };
  

});

const mapDispatchToProps = dispatch => ({

    onGetLab: email => dispatch(getLabDetail(email)),
    onUpdateLab: (lab, email) =>
    dispatch(updateLabRequest(lab, email)),
  });
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(LabProfile1)
);
